import React from 'react';
import { DropdownButtonPlusWrapper } from './styles/DropdownButtonPlusStyles';
import { Icon } from '../../../../../common/Icon';

export const DropdownButtonPlus = ({ onClick }) => (
  <DropdownButtonPlusWrapper role={'dropdown-button-plus'} onClick={() => onClick()}>
    <Icon name="add" width="100%" />
  </DropdownButtonPlusWrapper>
);
